import { getIn, useFormikContext } from 'formik';
import { useCallback } from 'react';

const useFieldContext = <T extends unknown>(
	name: string,
	disabled?: boolean,
) => {
	const context = useFormikContext();
	return {
		value: getIn(context.values, name) as T,
		error: getIn(context.errors, name),
		touched: getIn(context.touched, name),
		setFieldValue: useCallback(
			(val: T) => context.setFieldValue(name, val),
			// eslint-disable-next-line react-hooks/exhaustive-deps
			[name],
		),
		setFieldTouched: useCallback(
			() => context.setFieldTouched(name, true),
			// eslint-disable-next-line react-hooks/exhaustive-deps
			[name],
		),
		isDisabled: context.isSubmitting || disabled,
	};
};

export default useFieldContext;
